export const BASE_URL = "https://academy.w3era.com/api/";
export const BASE_URL_IMAGE = "https://academy.w3era.com/";

